// This file should not be a public module until
// we're happy with the API of these utils
// https://git.hubteam.com/HubSpot/foundations-theming/pull/243#issuecomment-10825842

export { useTheme } from './useTheme';
import { styledWithTheme } from './styledWithTheme';
export default styledWithTheme;